var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReservationList',_vm._b({ref:"reservationList",attrs:{"titleColor":"white"}},'ReservationList',{ ownerType: false, detailType: true, shopId: _vm.shopId },false))}
var staticRenderFns = []

export { render, staticRenderFns }